export const DEPARTMENTS_2024_2025 = [
    "Core",
    "Events",
    "Creative Visual Media",
    "Logistics & F&B",
    "Sponsorship",
    "Creative Content",
    "Web",
    "PR & Marketing"
] as const;

// infer a type from the list
export type Departments2024_2025 = typeof DEPARTMENTS_2024_2025[number];

export const DEPARTMENTS_2025_2026 = [
    "Core",
    "Events",
    "Creative Visual Media",
    "Logistics & F&B",
    "Sponsorship",
    "Marketing",
    "Web",
    "PR"
] as const;

export type Departments2025_2026 = typeof DEPARTMENTS_2025_2026[number];

export const POSSIBLE_YEARS = ["2025-2026", "2024-2025"] as const;

// infer a type again
export type PossibleYearsType = typeof POSSIBLE_YEARS[number];

export interface DEPARTMENT_MEMBER<T extends string = string> {
    name: string;
    image: string;
    role: string;
    department: T // TODO: change to be mandatory 
}

type DEPARTMENT_MAP<T extends string> = Record<T, string>;


// TODO: complete for other years
export const PERMIKA_2024_2025_DEPARTMENT: DEPARTMENT_MAP<Departments2024_2025> = {
    "Core": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/core_crop.webp",
    "Events": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/EVENT+TEAM_crop.webp",
    "Creative Visual Media": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/CVM+TEAM_crop.webp",
    "Logistics & F&B": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/LFB+TEAM_crop.webp",
    "Sponsorship": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/SPONSORSHIP+TEAM_crop.webp",
    "Creative Content": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/CREATIVE+CONTENT+TEAM_crop.webp",
    "Web": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/WEB+TEAM_crop.webp",
    "PR & Marketing": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/department/PR+%26+MKTING+TEAM_crop.webp" 
}

export const PERMIKA_2025_2026_DEPARTMENT: DEPARTMENT_MAP<Departments2025_2026> = { 
    "Core": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/core.webp", 
    "Events": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/event.webp", 
    "Creative Visual Media": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/vismed.webp", 
    "Logistics & F&B": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/fnb.webp", 
    "Sponsorship": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/sponsor.webp", 
    "Marketing": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/market.webp", 
    "Web": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/web.webp", 
    "PR": "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/department/pr.webp"
}

export const PERMIKA_2024_2025: DEPARTMENT_MEMBER[] = [
    {
        name: "Julian W.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CORE_Julian_crop.webp",
        role: "President",
        department: "Core"
    },
    {
        name: "Jesslyn A.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CORE_Jess_crop.webp",
        role: "Vice President",
        department: "Core"
    },
    {
        name: "Arlene P.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CORE_Arlene_crop.webp",
        role: "Secretary",
        department: "Core"
    },
    {
        name: "Keegan N.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CORE_Keegan_crop.webp",
        role: "Treasurer",
        department: "Core"
    },
    {
        name: "Josephine W.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/EVENT_jojo_crop.webp",
        role: "Event Director",
        department: "Events"
    },
    {
        name: "Olivia N.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/EVENT_Oliv_crop.webp",
        role: "Event Coordinator",
        department: "Events"
    },
    {
        name: "Nadya R.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/EVENT_nadya_crop.webp",
        role: "Event Coordinator",
        department: "Events"
    },
    {
        name: "William K.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/EVENT_William_crop.webp",
        role: "Event Coordinator",
        department: "Events"
    },
    {
        name: "Steffi L.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CVM_Steffi_crop.webp",
        role: "Creative Visual Media Director",
        department: "Creative Visual Media"
    },
    {
        name: "Tavannya G.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CVM_Tavannya_crop.webp",
        role: "Creative Visual Media Coordinator",
        department: "Creative Visual Media"
    },
    {
        name: "Kelly H.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CVM_Kelly_crop.webp",
        role: "Creative Visual Media Coordinator",
        department: "Creative Visual Media"
    },
    {
        name: "Gabriela E.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CC_Ellen_crop.webp",
        role: "Creative Content Director",
        department: "Creative Content"
    },
    {
        name: "Franklin L.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CC_Franklin_crop.webp",
        role: "Creative Content Coordinator",
        department: "Creative Content"
    },
    {
        name: "Mikael J.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CC_Jeremy_crop.webp",
        role: "Creative Content Coordinator",
        department: "Creative Content"
    },
    {
        name: "Meaghan U.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/CC_Meaghan_crop.webp",
        role: "Creative Content Coordinator",
        department: "Creative Content"
    },
    {
        name: "Reynella L.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/WEB_Rey_crop.webp",
        role: "Web Director",
        department: "Web"
    },
    {
        name: "Erick G.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/WEB_Erick_crop.webp",
        role: "Web Coordinator",
        department: "Web"
    },
    {
        name: "Cheryl G.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/WEB_Cheryl_crop.webp",
        role: "Web Coordinator",
        department: "Web"
    },
    {
        name: "Findytia T.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/PR_Findy_crop.webp",
        role: "PR & Marketing Director",
        department: "PR & Marketing"
    },
    {
        name: "Kihana S.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/PR_Sasha_crop.webp",
        role: "PR & Marketing Coordinator",
        department: "PR & Marketing"
    },
    {
        name: "Rosemary T.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/PR_Rosie_crop.webp",
        role: "PR & Marketing Coordinator",
        department: "PR & Marketing"
    },
    {
        name: "Alexis M.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/SPSR_Alexis_crop.webp",
        role: "Sponsorship Director",
        department: "Sponsorship"
    },
    {
        name: "Adella F.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/SPSR_Adella_crop.webp",
        role: "Sponsorship Coordinator",
        department: "Sponsorship"
    },
    {
        name: "Adrian J.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/LFB_Adrian_crop.webp",
        role: "Logistics & F&B Director",
        department: "Logistics & F&B"
    },
    {
        name: "Joycelynn T.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/LFB_Joyce_crop.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
    {
        name: "I Gede Nayaka",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/LFB_Nayaka_crop.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
    {
        name: "Josevan S.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/LFB_Jose_crop.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
    {
        name: "Isabella N.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2024-2025/execs/LFB_Bella_crop.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
]

export const PERMIKA_2025_2026: DEPARTMENT_MEMBER[] = [
    {
        name: "Josephine W.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Jojo+normal.webp",
        role: "President",
        department: "Core"
    }, 
    {
        name: "Olivia N.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Oliv+normal.webp",
        role: "Vice President",
        department: "Core"
    },
    {
        name: "Alexis M.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Alexis+normal.webp",
        role: "Secretary",
        department: "Core"
    },
    {
        name: "Rosemary T.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Rosie+normal.webp",
        role: "Treasurer",
        department: "Core"
    },
    {
        name: "Janice W.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Janice+normal.webp",
        role: "Events Director",
        department: "Events"
    },
    {
        name: "Samantha W.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Sam+normal.webp",
        role: "Events Coordinator",
        department: "Events"
    },
    {
        name: "Cheverly T.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Cheverly+normal.webp",
        role: "Events Coordinator",
        department: "Events"
    },
    {
        name: "Darryl D.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Darryl+normal.webp",
        role: "Events Coordinator",
        department: "Events"
    },
    {
        name: "Vanessa C.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Vancen+normal.webp",
        role: "Events Coordinator",
        department: "Events"
    },
    {
        name: "Naomi P.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Naomi+Normal.webp",
        role: "Creative Visual Media Director",
        department: "Creative Visual Media"
    },
    {
        name: "Britney P.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/BritneyNormal.webp",
        role: "Creative Visual Media Coordinator",
        department: "Creative Visual Media"
    },
    {
        name: "Joyce T.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Joyce+Normal.webp",
        role: "Creative Visual Media Coordinator",
        department: "Creative Visual Media"
    },
    {
        name: "Kaela T.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/KaelaNormal.webp",
        role: "Creative Visual Media Coordinator",
        department: "Creative Visual Media"
    },
    {
        name: "Nadeen H.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/nadeenNormal.webp",
        role: "Marketing Director",
        department: "Marketing"
    },
    {
        name: "Jessenia V.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/jessnormal.webp",
        role: "Marketing Coordinator",
        department: "Marketing"
    },
    {
        name: "Jefferson A.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/jeffNormal.webp",
        role: "Marketing Coordinator",
        department: "Marketing"
    },
    {
        name: "Aubrey M.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/aubreyNormal.webp",
        role: "Marketing Coordinator",
        department: "Marketing"
    },
    {
        name: "M. Abifani",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/abifunay.webp",
        role: "Marketing Coordinator",
        department: "Marketing"
    },
    {
        name: "Josevan S.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/joseNormal.webp",
        role: "Web Director",
        department: "Web"
    },
    {
        name: "C. Matthew",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/matwibs.webp",
        role: "Web Coordinator",
        department: "Web"
    },
    {
        name: "Calista B.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/VBNormal.webp",
        role: "PR Director",
        department: "PR"
    },
    {
        name: "Claressa E.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/ClaressaNormal.webp",
        role: "PR Coordinator",
        department: "PR"
    },
    {
        name: "Kalia E.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Kalia+Normal.webp",
        role: "Sponsorship Director",
        department: "Sponsorship"
    },
    {
        name: "Vanessa A.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Vanessa+Normal.webp",
        role: "Sponsorship Coordinator",
        department: "Sponsorship"
    },
    {
        name: "Anneke H.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Anneke+Normal.webp",
        role: "Logistics & F&B Director",
        department: "Logistics & F&B"
    },
    {
        name: "Wilbert K.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Wk+Normal.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
    {
        name: "Divia F.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Divia+Normal.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
    {
        name: "Martin Y.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Martin+Normal.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
    {
        name: "Kayleen S.",
        image: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/team/2025-2026/execs/Kayleen+Normal.webp",
        role: "Logistics & F&B Coordinator",
        department: "Logistics & F&B"
    },
]

interface PERMIKA_TEAM_MAP_ELEMENT {
    department: Record<string, string>;
    departmentMember: DEPARTMENT_MEMBER[];
    departmentsList: readonly string[];
}

type PERMIKA_TEAM_MAP = Record<PossibleYearsType, PERMIKA_TEAM_MAP_ELEMENT>;

export const PERMIKA_TEAM: PERMIKA_TEAM_MAP = {
    "2025-2026": {
        department: PERMIKA_2025_2026_DEPARTMENT,
        departmentMember: PERMIKA_2025_2026,
        departmentsList: DEPARTMENTS_2025_2026
    },
    "2024-2025": {
        department: PERMIKA_2024_2025_DEPARTMENT,
        departmentMember: PERMIKA_2024_2025,
        departmentsList: DEPARTMENTS_2024_2025
    },

}